import { render, staticRenderFns } from "./BlockStatus2El.vue?vue&type=template&id=31528772&scoped=true&"
import script from "./BlockStatus2El.vue?vue&type=script&lang=ts&"
export * from "./BlockStatus2El.vue?vue&type=script&lang=ts&"
import style0 from "./BlockStatus2El.vue?vue&type=style&index=0&id=31528772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31528772",
  null
  
)

export default component.exports